/* eslint-disable camelcase */
import { setTrackCallback, setUserCallback } from "@companion-core/shared/app/tracking";
import { Page, Click, Publisher } from "@companion-core/shared/app/Interfaces/tracking";
import { setCustomVars } from "@companion-core/shared/app/tracking/customVars";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";

export function sendPianoId() {
  const { piano_id } = useConfigStore.getState().publicConfig?.data;
  window?.dataLayer.push({
    event: "PianoID",
    piano_id,
  });
}

export function initTracking() {
  setTrackCallback((event: string, params: Page | Click | Publisher) => {
    window?.dataLayer.push({
      event,
      ...params,
    });
  });
  setUserCallback((userId: string, subscriptionsId: string, userCategory = "", storeId = false) => {
    const authentification = userId ? 1 : 2;
    setCustomVars({ subscription_UUID: subscriptionsId, authentification });
    window?.dataLayer.push({
      event: "setUser",
      userId,
      userCategory,
      storeId,
    });
  });
}
